var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 3.25415H2.5C1.94772 3.25415 1.5 3.70187 1.5 4.25415V13.746C1.5 14.2983 1.94772 14.746 2.5 14.746H15.5C16.0523 14.746 16.5 14.2983 16.5 13.746V4.25415C16.5 3.70187 16.0523 3.25415 15.5 3.25415Z",
    stroke: "currentColor",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.88728 3.63618C1.59897 3.42229 1.19186 3.48261 0.977972 3.77092C0.764082 4.05923 0.824411 4.46634 1.11272 4.68023L1.88728 3.63618ZM16.887 4.68046C17.1754 4.46675 17.236 4.05967 17.0223 3.77124C16.8085 3.4828 16.4015 3.42223 16.113 3.63594L16.887 4.68046ZM8.39983 9.27704L8.78711 8.75501L8.39983 9.27704ZM1.11272 4.68023L8.01255 9.79907L8.78711 8.75501L1.88728 3.63618L1.11272 4.68023ZM9.97795 9.79966L16.887 4.68046L16.113 3.63594L9.20402 8.75514L9.97795 9.79966ZM8.01255 9.79907C8.59609 10.232 9.39415 10.2322 9.97795 9.79966L9.20402 8.75514C9.08018 8.84689 8.9109 8.84684 8.78711 8.75501L8.01255 9.79907Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.6c898e6a.svg";
export { ForwardRef as ReactComponent };